// Master SEO/GEO data: localities, subjects, exams, classes, boards, topics, countries.
// Drives programmatic SEO landing pages for Jabalpur, Nagpur, India, International.

export const CITIES = {
  jabalpur: {
    slug: "jabalpur",
    name: "Jabalpur",
    state: "Madhya Pradesh",
    pincode: "482001-482011",
    phone: "+91 7000530316",
    phoneRaw: "+917000530316",
    whatsapp: "917000530316",
    address: "Ghadi Chowk, Vijay Nagar, Jabalpur, Madhya Pradesh 482002",
    mapsEmbed:
      "https://www.google.com/maps?q=Ghadi+Chowk,+Vijay+Nagar,+Jabalpur,+Madhya+Pradesh+482002&output=embed",
    gbp: "https://share.google/U5I4g0Uc6H1Y3yFVw",
    geo: { lat: 23.1815, lng: 79.9864 },
    primaryBoards: ["CBSE", "ICSE", "MP Board"],
  },
  nagpur: {
    slug: "nagpur",
    name: "Nagpur",
    state: "Maharashtra",
    pincode: "440001-440037",
    phone: "+91 9977944770",
    phoneRaw: "+919977944770",
    whatsapp: "919977944770",
    address:
      "Plot No. A, 598, Mata Mandir Rd, near Children Traffic Park, Dharampeth, Nagpur, Maharashtra 440010",
    mapsEmbed:
      "https://www.google.com/maps?q=Mata+Mandir+Rd,+Dharampeth,+Nagpur,+Maharashtra+440010&output=embed",
    gbp: "https://share.google/lPOtP7maF68D1cCCb",
    geo: { lat: 21.1458, lng: 79.0882 },
    primaryBoards: ["CBSE", "ICSE", "Maharashtra Board"],
  },
};

// Micro-localities by city (each becomes its own SEO landing page)
export const LOCALITIES = {
  jabalpur: [
    { slug: "vijay-nagar", name: "Vijay Nagar", pincode: "482002" },
    { slug: "napier-town", name: "Napier Town", pincode: "482001" },
    { slug: "wright-town", name: "Wright Town", pincode: "482002" },
    { slug: "gorakhpur", name: "Gorakhpur", pincode: "482001" },
    { slug: "adhartal", name: "Adhartal", pincode: "482004" },
    { slug: "garha", name: "Garha", pincode: "482003" },
    { slug: "madan-mahal", name: "Madan Mahal", pincode: "482002" },
    { slug: "tilhari", name: "Tilhari", pincode: "482021" },
    { slug: "ranjhi", name: "Ranjhi", pincode: "482005" },
    { slug: "sadar", name: "Sadar", pincode: "482001" },
    { slug: "gwarighat", name: "Gwarighat", pincode: "482008" },
    { slug: "katanga", name: "Katanga", pincode: "482002" },
    { slug: "karmeta", name: "Karmeta", pincode: "482002" },
    { slug: "medical-road", name: "Medical Road", pincode: "482003" },
    { slug: "civil-lines", name: "Civil Lines", pincode: "482001" },
    { slug: "damoh-naka", name: "Damoh Naka", pincode: "482002" },
    { slug: "shastri-nagar", name: "Shastri Nagar", pincode: "482002" },
    { slug: "south-civil-lines", name: "South Civil Lines", pincode: "482001" },
    { slug: "yadav-colony", name: "Yadav Colony", pincode: "482002" },
    { slug: "russel-chowk", name: "Russel Chowk", pincode: "482001" },
    { slug: "pachpedi", name: "Pachpedi", pincode: "482001" },
  ],
  nagpur: [
    { slug: "dharampeth", name: "Dharampeth", pincode: "440010" },
    { slug: "civil-lines", name: "Civil Lines", pincode: "440001" },
    { slug: "pratap-nagar", name: "Pratap Nagar", pincode: "440022" },
    { slug: "ramdaspeth", name: "Ramdaspeth", pincode: "440010" },
    { slug: "wardha-road", name: "Wardha Road", pincode: "440015" },
    { slug: "narendra-nagar", name: "Narendra Nagar", pincode: "440015" },
    { slug: "trimurti-nagar", name: "Trimurti Nagar", pincode: "440022" },
    { slug: "laxmi-nagar", name: "Laxmi Nagar", pincode: "440022" },
    { slug: "besa", name: "Besa", pincode: "440034" },
    { slug: "manish-nagar", name: "Manish Nagar", pincode: "440015" },
    { slug: "hingna", name: "Hingna", pincode: "440016" },
    { slug: "sadar", name: "Sadar", pincode: "440001" },
    { slug: "mankapur", name: "Mankapur", pincode: "440030" },
    { slug: "nandanvan", name: "Nandanvan", pincode: "440009" },
    { slug: "jaripatka", name: "Jaripatka", pincode: "440014" },
    { slug: "koradi-road", name: "Koradi Road", pincode: "441111" },
    { slug: "friends-colony", name: "Friends Colony", pincode: "440022" },
    { slug: "medical-square", name: "Medical Square", pincode: "440003" },
    { slug: "seminary-hills", name: "Seminary Hills", pincode: "440006" },
    { slug: "gokulpeth", name: "Gokulpeth", pincode: "440010" },
    { slug: "bajaj-nagar", name: "Bajaj Nagar", pincode: "440010" },
    { slug: "dhantoli", name: "Dhantoli", pincode: "440012" },
    { slug: "ambazari", name: "Ambazari", pincode: "440033" },
    { slug: "chhatrapati-square", name: "Chhatrapati Square", pincode: "440015" },
  ],
};

// Subject pages — exhaustive coverage for AI/programmatic SEO
export const SUBJECTS = [
  // Core school subjects
  { slug: "mathematics", name: "Mathematics", aliases: ["math", "maths"], hot: true },
  { slug: "science", name: "Science", hot: true },
  { slug: "physics", name: "Physics", hot: true },
  { slug: "chemistry", name: "Chemistry", hot: true },
  { slug: "biology", name: "Biology", hot: true },
  { slug: "english", name: "English", hot: true },
  { slug: "hindi", name: "Hindi", hot: true },
  { slug: "sanskrit", name: "Sanskrit" },
  { slug: "social-science", name: "Social Science" },
  { slug: "history", name: "History" },
  { slug: "geography", name: "Geography" },
  { slug: "political-science", name: "Political Science" },
  // Commerce
  { slug: "accounts", name: "Accounts", hot: true },
  { slug: "economics", name: "Economics", hot: true },
  { slug: "business-studies", name: "Business Studies" },
  { slug: "commerce", name: "Commerce" },
  { slug: "statistics", name: "Statistics" },
  // Computer & coding
  { slug: "computer-science", name: "Computer Science", hot: true },
  { slug: "information-technology", name: "Information Technology" },
  { slug: "coding", name: "Coding", hot: true },
  { slug: "python", name: "Python", hot: true },
  { slug: "java", name: "Java" },
  { slug: "c-plus-plus", name: "C++" },
  { slug: "javascript", name: "JavaScript" },
  { slug: "web-development", name: "Web Development" },
  { slug: "ai-machine-learning", name: "AI & Machine Learning" },
  { slug: "robotics", name: "Robotics" },
  { slug: "data-science", name: "Data Science" },
  // Engineering subjects
  { slug: "engineering-subjects", name: "Engineering Subjects" },
  { slug: "engineering-drawing", name: "Engineering Drawing" },
  { slug: "engineering-mechanics", name: "Engineering Mechanics" },
  // Languages
  { slug: "spoken-english", name: "Spoken English", hot: true },
  { slug: "french", name: "French" },
  { slug: "german", name: "German" },
  { slug: "spanish", name: "Spanish" },
  { slug: "japanese", name: "Japanese" },
  { slug: "mandarin", name: "Mandarin" },
  // Test prep
  { slug: "ielts", name: "IELTS" },
  { slug: "toefl", name: "TOEFL" },
  { slug: "sat", name: "SAT" },
  { slug: "gre", name: "GRE" },
  { slug: "gmat", name: "GMAT" },
  { slug: "pte", name: "PTE" },
  { slug: "duolingo", name: "Duolingo English Test" },
  // Skill / co-curricular
  { slug: "abacus", name: "Abacus" },
  { slug: "vedic-maths", name: "Vedic Maths" },
  { slug: "phonics", name: "Phonics" },
  { slug: "handwriting", name: "Handwriting Improvement" },
  { slug: "public-speaking", name: "Public Speaking" },
  { slug: "personality-development", name: "Personality Development" },
  { slug: "creative-writing", name: "Creative Writing" },
  // Arts & co-curricular
  { slug: "music", name: "Music" },
  { slug: "dance", name: "Dance" },
  { slug: "art", name: "Art" },
  { slug: "drawing", name: "Drawing" },
  { slug: "chess", name: "Chess" },
  // Special education & support
  { slug: "special-education", name: "Special Education" },
  { slug: "autism-support", name: "Autism Support Tutor" },
  { slug: "speech-therapy", name: "Speech Therapy" },
  { slug: "dyslexia-support", name: "Dyslexia Support" },
  // Help types
  { slug: "homework-help", name: "Homework Help" },
  { slug: "assignment-help", name: "Assignment Help" },
  { slug: "exam-preparation", name: "Exam Preparation" },
  { slug: "crash-course", name: "Crash Course" },
];

// Classes / Grades — extended
export const CLASSES = [
  { slug: "nursery", label: "Nursery", short: "Nursery" },
  { slug: "lkg", label: "LKG", short: "LKG" },
  { slug: "ukg", label: "UKG", short: "UKG" },
  { slug: "class-1", label: "Class 1", short: "1" },
  { slug: "class-2", label: "Class 2", short: "2" },
  { slug: "class-3", label: "Class 3", short: "3" },
  { slug: "class-4", label: "Class 4", short: "4" },
  { slug: "class-5", label: "Class 5", short: "5" },
  { slug: "class-6", label: "Class 6", short: "6" },
  { slug: "class-7", label: "Class 7", short: "7" },
  { slug: "class-8", label: "Class 8", short: "8" },
  { slug: "class-9", label: "Class 9", short: "9" },
  { slug: "class-10", label: "Class 10", short: "10", board: true },
  { slug: "class-11", label: "Class 11", short: "11" },
  { slug: "class-12", label: "Class 12", short: "12", board: true },
  { slug: "dropper", label: "Dropper / Repeater", short: "Dropper" },
  { slug: "foundation", label: "Foundation Course", short: "Foundation" },
  { slug: "college-students", label: "College Students", short: "College" },
  { slug: "adult-learning", label: "Adult Learning", short: "Adult" },
  { slug: "professional-courses", label: "Professional Courses", short: "Pro" },
];

// Boards — extended with NIOS, AP, GCSE, etc.
export const BOARDS = [
  { slug: "cbse", name: "CBSE", full: "Central Board of Secondary Education" },
  { slug: "icse", name: "ICSE", full: "Indian Certificate of Secondary Education" },
  { slug: "isc", name: "ISC", full: "Indian School Certificate (Class 12)" },
  { slug: "mp-board", name: "MP Board", full: "Madhya Pradesh Board (MPBSE)" },
  { slug: "maharashtra-board", name: "Maharashtra Board", full: "Maharashtra SSC/HSC Board" },
  { slug: "state-board", name: "State Board", full: "Indian State Boards" },
  { slug: "nios", name: "NIOS", full: "National Institute of Open Schooling" },
  { slug: "ib", name: "IB", full: "International Baccalaureate (PYP/MYP/DP)" },
  { slug: "igcse", name: "IGCSE", full: "Cambridge IGCSE" },
  { slug: "gcse", name: "GCSE", full: "General Certificate of Secondary Education (UK)" },
  { slug: "a-level", name: "A-Level", full: "Cambridge / Edexcel A-Levels" },
  { slug: "ap-curriculum", name: "AP Curriculum", full: "Advanced Placement (College Board)" },
  { slug: "american-curriculum", name: "American Curriculum", full: "US Common Core / AP" },
  { slug: "australian-curriculum", name: "Australian Curriculum", full: "ACARA" },
  { slug: "canadian-curriculum", name: "Canadian Curriculum", full: "Ontario / Alberta" },
];

// Competitive exams
export const EXAMS = [
  { slug: "neet", name: "NEET", full: "National Eligibility cum Entrance Test (Medical)" },
  { slug: "jee", name: "JEE", full: "Joint Entrance Examination (Engineering)" },
  { slug: "cuet", name: "CUET", full: "Common University Entrance Test" },
  { slug: "olympiad", name: "Olympiad", full: "Maths / Science / English Olympiads" },
  { slug: "foundation", name: "Foundation", full: "Foundation Courses (Class 6-10)" },
  { slug: "ntse", name: "NTSE", full: "National Talent Search Examination" },
];

// International countries (for /online-tuition/:country) — 25 high-NRI markets
export const COUNTRIES = [
  // Tier-1 NRI markets
  { slug: "usa", name: "USA", curriculum: "US Common Core / AP", tz: "EST/PST", flag: "🇺🇸" },
  { slug: "uk", name: "UK", curriculum: "British / GCSE / A-Levels", tz: "GMT", flag: "🇬🇧" },
  { slug: "canada", name: "Canada", curriculum: "Ontario / Alberta / BC", tz: "EST/PST", flag: "🇨🇦" },
  { slug: "australia", name: "Australia", curriculum: "ACARA / NSW / Victoria", tz: "AEST", flag: "🇦🇺" },
  { slug: "new-zealand", name: "New Zealand", curriculum: "NCEA / Cambridge", tz: "NZST", flag: "🇳🇿" },
  // GCC — strongest NRI demand
  { slug: "uae", name: "UAE", curriculum: "CBSE / IGCSE / American / IB", tz: "GST", flag: "🇦🇪" },
  { slug: "dubai", name: "Dubai", curriculum: "CBSE / IGCSE / American / IB", tz: "GST", flag: "🇦🇪" },
  { slug: "abu-dhabi", name: "Abu Dhabi", curriculum: "CBSE / IGCSE / American / IB", tz: "GST", flag: "🇦🇪" },
  { slug: "saudi-arabia", name: "Saudi Arabia", curriculum: "CBSE / IGCSE / American", tz: "AST", flag: "🇸🇦" },
  { slug: "qatar", name: "Qatar", curriculum: "CBSE / IGCSE / American", tz: "AST", flag: "🇶🇦" },
  { slug: "kuwait", name: "Kuwait", curriculum: "CBSE / IGCSE / American", tz: "AST", flag: "🇰🇼" },
  { slug: "oman", name: "Oman", curriculum: "CBSE / IGCSE", tz: "GST", flag: "🇴🇲" },
  { slug: "bahrain", name: "Bahrain", curriculum: "CBSE / IGCSE / IB", tz: "AST", flag: "🇧🇭" },
  // South-East Asia
  { slug: "singapore", name: "Singapore", curriculum: "IB / Cambridge / SEAB", tz: "SGT", flag: "🇸🇬" },
  { slug: "malaysia", name: "Malaysia", curriculum: "IGCSE / IB / CBSE", tz: "MYT", flag: "🇲🇾" },
  { slug: "hong-kong", name: "Hong Kong", curriculum: "IGCSE / IB / DSE", tz: "HKT", flag: "🇭🇰" },
  { slug: "japan", name: "Japan", curriculum: "IB / British", tz: "JST", flag: "🇯🇵" },
  { slug: "south-korea", name: "South Korea", curriculum: "IB / American / British", tz: "KST", flag: "🇰🇷" },
  // Europe
  { slug: "germany", name: "Germany", curriculum: "IB / British / Abitur", tz: "CET", flag: "🇩🇪" },
  { slug: "france", name: "France", curriculum: "IB / British / Bac", tz: "CET", flag: "🇫🇷" },
  { slug: "italy", name: "Italy", curriculum: "IB / British", tz: "CET", flag: "🇮🇹" },
  { slug: "switzerland", name: "Switzerland", curriculum: "IB / British / American", tz: "CET", flag: "🇨🇭" },
  { slug: "netherlands", name: "Netherlands", curriculum: "IB / British", tz: "CET", flag: "🇳🇱" },
  { slug: "ireland", name: "Ireland", curriculum: "Leaving Cert / IB", tz: "GMT", flag: "🇮🇪" },
  { slug: "europe", name: "Europe", curriculum: "IB / Cambridge / National", tz: "CET", flag: "🇪🇺" },
  { slug: "worldwide", name: "Worldwide", curriculum: "All major curricula", tz: "Any", flag: "🌍" },
];

// City-level topic catalog: each entry → /:city/:slug
// Generates H1, intro, FAQs from templates in seoCopy.js.
export const CITY_TOPICS = [
  // Home Tuition family (all high-intent variants)
  { slug: "home-tuition", kind: "service", label: "Home Tuition", h1: "Home Tuition in {city}" },
  { slug: "home-tutors", kind: "service", label: "Home Tutors", h1: "Home Tutors in {city}" },
  { slug: "home-teachers", kind: "service", label: "Home Teachers", h1: "Home Teachers in {city}" },
  { slug: "best-home-tuition", kind: "service", label: "Best Home Tuition", h1: "Best Home Tuition in {city}" },
  { slug: "best-home-tutors", kind: "service", label: "Best Home Tutors", h1: "Best Home Tutors in {city}" },
  { slug: "top-home-tutors", kind: "service", label: "Top Home Tutors", h1: "Top Home Tutors in {city}" },
  { slug: "affordable-home-tuition", kind: "service", label: "Affordable Home Tuition", h1: "Affordable Home Tuition in {city}" },
  { slug: "home-tutor-near-me", kind: "service", label: "Home Tutor Near Me", h1: "Home Tutor Near Me in {city}" },
  { slug: "private-tutors", kind: "service", label: "Private Tutors", h1: "Private Tutors in {city}" },
  { slug: "personal-tutor", kind: "service", label: "Personal Tutor", h1: "Personal Tutor in {city}" },
  { slug: "one-to-one-tutor", kind: "service", label: "One-to-One Tutor", h1: "One-to-One Tutor in {city}" },
  { slug: "female-home-tutors", kind: "service", label: "Female Home Tutors", h1: "Female Home Tutors in {city}" },
  { slug: "male-home-tutors", kind: "service", label: "Male Home Tutors", h1: "Male Home Tutors in {city}" },
  { slug: "experienced-home-tutors", kind: "service", label: "Experienced Home Tutors", h1: "Experienced Home Tutors in {city}" },
  { slug: "verified-home-tutors", kind: "service", label: "Verified Home Tutors", h1: "Verified Home Tutors in {city}" },
  { slug: "premium-home-tutors", kind: "service", label: "Premium Home Tutors", h1: "Premium Home Tutors in {city}" },
  { slug: "elite-home-tutors", kind: "service", label: "Elite Home Tutors", h1: "Elite Home Tutors in {city}" },
  { slug: "home-tuition-services", kind: "service", label: "Home Tuition Services", h1: "Home Tuition Services in {city}" },
  { slug: "home-tuition-agency", kind: "service", label: "Home Tuition Agency", h1: "Top Home Tuition Agency in {city}" },
  // Modes
  { slug: "online-tuition", kind: "service", label: "Online Tuition", h1: "Online Tuition in {city}" },
  { slug: "online-home-tuition", kind: "service", label: "Online Home Tuition", h1: "Online Home Tuition in {city}" },
  { slug: "offline-home-tuition", kind: "service", label: "Offline Home Tuition", h1: "Offline Home Tuition in {city}" },
  { slug: "weekend-tuition", kind: "service", label: "Weekend Tuition", h1: "Weekend Tuition in {city}" },
  { slug: "daily-tuition", kind: "service", label: "Daily Tuition", h1: "Daily Home Tuition in {city}" },
  { slug: "coaching-classes", kind: "service", label: "Coaching Classes", h1: "Coaching Classes in {city}" },
  { slug: "private-coaching", kind: "service", label: "Private Coaching", h1: "Private Coaching in {city}" },
  { slug: "academic-coaching", kind: "service", label: "Academic Coaching", h1: "Academic Coaching in {city}" },
  { slug: "one-to-one-coaching", kind: "service", label: "One-to-One Coaching", h1: "One-to-One Coaching in {city}" },
  // Competitive
  { slug: "neet-coaching", kind: "exam", exam: "neet", label: "NEET Coaching", h1: "NEET Coaching in {city}" },
  { slug: "jee-coaching", kind: "exam", exam: "jee", label: "JEE Coaching", h1: "JEE Coaching in {city}" },
  { slug: "cuet-coaching", kind: "exam", exam: "cuet", label: "CUET Coaching", h1: "CUET Coaching in {city}" },
  { slug: "olympiad-coaching", kind: "exam", exam: "olympiad", label: "Olympiad Coaching", h1: "Olympiad Coaching in {city}" },
  { slug: "ntse-preparation", kind: "exam", exam: "ntse", label: "NTSE Preparation", h1: "NTSE Preparation in {city}" },
  { slug: "neet-home-tutors", kind: "exam", exam: "neet", label: "NEET Home Tutors", h1: "NEET Home Tutors in {city}" },
  { slug: "jee-home-tutors", kind: "exam", exam: "jee", label: "JEE Home Tutors", h1: "JEE Home Tutors in {city}" },
  { slug: "neet-crash-course", kind: "exam", exam: "neet", label: "NEET Crash Course", h1: "NEET Crash Course in {city}" },
  { slug: "jee-crash-course", kind: "exam", exam: "jee", label: "JEE Crash Course in {city}", h1: "JEE Crash Course in {city}" },
  // Languages & Computer & Skills
  { slug: "spoken-english-classes", kind: "service", label: "Spoken English Classes", h1: "Spoken English Classes in {city}" },
  { slug: "ielts-coaching", kind: "service", label: "IELTS Coaching", h1: "IELTS Coaching in {city}" },
  { slug: "computer-classes", kind: "service", label: "Computer Classes", h1: "Computer Classes in {city}" },
  { slug: "coding-classes", kind: "service", label: "Coding Classes for Kids", h1: "Coding Classes for Kids in {city}" },
  { slug: "abacus-classes", kind: "service", label: "Abacus Classes", h1: "Abacus Classes in {city}" },
  { slug: "vedic-maths-classes", kind: "service", label: "Vedic Maths Classes", h1: "Vedic Maths Classes in {city}" },
  { slug: "phonics-classes", kind: "service", label: "Phonics Classes", h1: "Phonics Classes in {city}" },
  { slug: "handwriting-improvement", kind: "service", label: "Handwriting Improvement", h1: "Handwriting Improvement Classes in {city}" },
  // Help types
  { slug: "homework-help", kind: "service", label: "Homework Help", h1: "Homework Help in {city}" },
  { slug: "assignment-help", kind: "service", label: "Assignment Help", h1: "Assignment Help in {city}" },
  // Class-wise (generated below also via CLASSES loop)
  ...CLASSES.map((c) => ({
    slug: `${c.slug}-tuition`,
    kind: "class",
    classSlug: c.slug,
    label: `${c.label} Tuition`,
    h1: `${c.label} Tuition in {city}`,
  })),
  // Board-wise (all 15 boards)
  ...BOARDS.map((b) => ({
    slug: `${b.slug}-tuition`,
    kind: "board",
    boardSlug: b.slug,
    label: `${b.name} Tuition`,
    h1: `${b.name} Tuition in {city}`,
  })),
  // Subject-wise (top + hot subjects — ~15 hot subjects → ~30 cross URLs)
  ...SUBJECTS.filter((s) => s.hot).map((s) => ({
    slug: `${s.slug}-tuition`,
    kind: "subject",
    subjectSlug: s.slug,
    label: `${s.name} Tuition`,
    h1: `${s.name} Tuition in {city}`,
  })),
];

export const CITY_TOPIC_MAP = Object.fromEntries(CITY_TOPICS.map((t) => [t.slug, t]));

// Helper lookups
export const LOCALITY_MAP = {
  jabalpur: Object.fromEntries(LOCALITIES.jabalpur.map((l) => [l.slug, l])),
  nagpur: Object.fromEntries(LOCALITIES.nagpur.map((l) => [l.slug, l])),
};
export const SUBJECT_MAP = Object.fromEntries(SUBJECTS.map((s) => [s.slug, s]));
export const BOARD_MAP = Object.fromEntries(BOARDS.map((b) => [b.slug, b]));
export const EXAM_MAP = Object.fromEntries(EXAMS.map((e) => [e.slug, e]));
export const CLASS_MAP = Object.fromEntries(CLASSES.map((c) => [c.slug, c]));
export const COUNTRY_MAP = Object.fromEntries(COUNTRIES.map((c) => [c.slug, c]));

// Trust signals (used in schema + on page)
export const TRUST = {
  ratingValue: 4.9,
  reviewCount: 1247,
  studentCount: "10,000+",
  yearsExperience: 12,
  tutorCount: "5000+",
};
